import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import teamOne from '../../assets/images/team1.jpg';
import teamTwo from '../../assets/images/team2.jpg';
import teamThree from '../../assets/images/team3.jpg';
import teamFour from '../../assets/images/team4.jpg';
import teamFive from '../../assets/images/team5.jpg';

const options = {
    infinite: true,
    arrows: false,
    dots: true,
    speed: 2000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 2 } },
        { breakpoint: 786, settings: { slidesToShow: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1 } },
    ]
}

class Team extends React.Component {
    render(){
        return null; // Hidden: placeholder team members
        /* eslint-disable no-unreachable */
        return (
            <section id="team" className="team-area uk-team uk-section">
                <div className="uk-container">
                    <div className="uk-section-title section-title">
                        <span>Meet Our Experts</span>
                        <h2>Our Team</h2>
                        <div className="bar"></div>
                    </div>
                </div>

                <Slider
                    className="team-slides"
                    {...options}
                >
                    <div className="single-team">
                        <ul className="team-social">
                            <li><a href="https://www.linkedin.com/" rel="noopener noreferrer" target="_blank"><i className="flaticon-linkedin"></i></a></li>
                        </ul>

                        <img src={teamOne} alt="team member" />

                        <div className="team-content">
                            <h3>Team Member</h3>
                            <span>Lead Software Engineer</span>
                        </div>
                    </div>

                    <div className="single-team">
                        <ul className="team-social">
                            <li><a href="https://www.linkedin.com/" rel="noopener noreferrer" target="_blank"><i className="flaticon-linkedin"></i></a></li>
                        </ul>

                        <img src={teamTwo} alt="team member" />

                        <div className="team-content">
                            <h3>Team Member</h3>
                            <span>AI / ML Engineer</span>
                        </div>
                    </div>

                    <div className="single-team">
                        <ul className="team-social">
                            <li><a href="https://www.linkedin.com/" rel="noopener noreferrer" target="_blank"><i className="flaticon-linkedin"></i></a></li>
                        </ul>

                        <img src={teamThree} alt="team member" />

                        <div className="team-content">
                            <h3>Team Member</h3>
                            <span>Full Stack Developer</span>
                        </div>
                    </div>

                    <div className="single-team">
                        <ul className="team-social">
                            <li><a href="https://www.linkedin.com/" rel="noopener noreferrer" target="_blank"><i className="flaticon-linkedin"></i></a></li>
                        </ul>

                        <img src={teamFour} alt="team member" />

                        <div className="team-content">
                            <h3>Team Member</h3>
                            <span>DevOps Engineer</span>
                        </div>
                    </div>

                    <div className="single-team">
                        <ul className="team-social">
                            <li><a href="https://www.linkedin.com/" rel="noopener noreferrer" target="_blank"><i className="flaticon-linkedin"></i></a></li>
                        </ul>

                        <img src={teamFive} alt="team member" />

                        <div className="team-content">
                            <h3>Team Member</h3>
                            <span>Product Designer</span>
                        </div>
                    </div>
                </Slider>
            </section>
        );
    }
}

export default Team;
